import { TypedDispatch, TypedThunk } from "App/Store";
import { BRACKET_PREVIEW_ACTION } from "core/constants/Actions";
import { getBracketPreview } from "core/services/Bracket";
export function getBracketPreviewDetails(
  tournamentId: string | number,
  bracketType: string,
  thirdPlaceMatch: string
): TypedThunk {
  return async (dispatch: TypedDispatch): Promise<void> => {
    dispatch({ type: BRACKET_PREVIEW_ACTION.REQUEST });
    const apiResponse = await getBracketPreview(
      tournamentId,
      bracketType,
      thirdPlaceMatch
    );
    if (apiResponse.status && apiResponse.data) {
      dispatch({
        type: BRACKET_PREVIEW_ACTION.SUCCESS,
        payload: { bracketPreview: apiResponse.data.bracketPreview },
      });
    } else {
      dispatch({
        type: BRACKET_PREVIEW_ACTION.FAILURE,
      });
    }
  };
}
